import _ from 'underscore';

const dayNames = [
  'mon',
  'tue',
  'wed',
  'thu',
  'fri',
  'sat',
  'sun',
  'holiday',
];

const safeParse = (json, fallback) => {
  try {
    return JSON.parse(json);
  } catch (e) {
    return fallback;
  }
};

const parseKey = (key) => {
  const reKey = /^(\w+)_(\d)_(\w+)$/i;
  const match = key.match(reKey);
  if (match && match.length > 3) {
    return {
      day: match[1].toLowerCase(),
      index: Number(match[2]),
      isOpen: match[3].toLowerCase() === 'open',
    };
  }
  return null;
};

export const isHourValid = (hour, is12Hr) => (
  is12Hr ? (hour >= 0 && hour <= 12) : (hour >= 0 && hour < 24)
);

export const isMinuteValid = minute => (
  minute >= 0 && minute < 60
);

const getTimeSlotsOfDay = (day, timesArray) => {
  const openTimes = _.chain(timesArray)
    .filter(item => item.day === day && item.isOpen)
    .sortBy('index')
    .value();
  const closeTimes = _.chain(timesArray)
    .filter(item => item.day === day && !item.isOpen)
    .sortBy('index')
    .value();

  if (_.isEmpty(openTimes) || _.isEmpty(closeTimes) ||
    openTimes.length !== closeTimes.length) {
    return [];
  }

  const timeSlots = [];
  for (let i = 0; i < openTimes.length; i += 1) {
    timeSlots.push({
      index: i,
      openHour: openTimes[i].hour,
      openMinute: openTimes[i].minute,
      closeHour: closeTimes[i].hour,
      closeMinute: closeTimes[i].minute,
    });
  }

  return timeSlots;
};

// try parse a string like 9 AM or 9:00 PM
// if parse fail, return null
export const tryParseTimeString = (timeString) => {
  if (typeof (timeString) !== 'string') {
    return null;
  }

  const reShort = /^(\d{1,2})\s*(AM|PM)?$/i; // 9 pm
  const reLong = /^(\d{1,2}):(\d{2})\s*(AM|PM)?$/i; // 9:00 pm
  const is12Hr = /AM|PM/i.test(timeString);
  const isPM = /PM/i.test(timeString);
  let match;
  let hour;
  let minute;

  if (reShort.test(timeString)) {
    match = timeString.match(reShort);
    if (match.length < 2) {
      return null;
    }
    hour = Number(match[1]);
    minute = 0;
  } else if (reLong.test(timeString)) {
    match = timeString.match(reLong);
    if (match.length < 3) {
      return null;
    }
    hour = Number(match[1]);
    minute = Number(match[2]);
  }

  if (isHourValid(hour, is12Hr) && isMinuteValid(minute)) {
    // 12 AM should be saved as 0 for 24-hours
    if (is12Hr && !isPM && hour === 12) {
      return {
        hour: 0,
        minute,
      };
    }
    return {
      hour: isPM && hour < 12 ? hour + 12 : hour,
      minute,
    };
  }

  return null;
};

export const mapFbHours = (fbHoursJson) => {
  const fbHours = safeParse(fbHoursJson, []);
  const arr = _.map(fbHours, (value, key) => {
    const parsedKey = parseKey(key);
    const parsedTime = tryParseTimeString(value);
    return {
      ...parsedKey,
      ...parsedTime,
    };
  });

  const hoursConfig = _.map(dayNames, day => ({
    day,
    timeSlots: getTimeSlotsOfDay(day, arr),
    isValid: true,
  }), this);

  return hoursConfig;
};

// Retrieve hour and minute from Bing Places hours
// Bing places hour format: 09:00:00 AM/PM
// Retrive hour and minute like:
// {hour: 9, minute: 0}
const parseBPHour = (hour) => {
  if (typeof hour !== 'string') {
    return null;
  }

  const temp = hour.split(/\s+/);
  temp[0] = temp[0].split(':').slice(0, 2).join(':');
  const formattedStr = temp.join(' ');

  return tryParseTimeString(formattedStr);
};

// Map Bing Places hours to business hours used in Editor.
export const mapBPTime = (BPHours = []) => {
  const timeSlots = [];
  for (let index = 0; index < BPHours.length; index += 1) {
    const BPHour = BPHours[index];
    const { StartTime, EndTime } = BPHour;
    const formattedStartTime = parseBPHour(StartTime);
    const formattedEndTime = parseBPHour(EndTime);

    if (!formattedStartTime || !formattedEndTime) {
      return [];
    }

    const { hour: openHour, minute: openMinute } = formattedStartTime;
    const { hour: closeHour, minute: closeMinute } = formattedEndTime;
    timeSlots.push({
      openHour,
      openMinute,
      index,
      isValid: true,
      closeHour,
      closeMinute,
    });
  }

  return timeSlots;
};
